// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 退出BOSS后台登录 BOSS后台用户退出登录，从Cookie中读取refresh_token并使其失效 POST /bossApi/conference/core/auth/v1/logout */
export async function logoutBoss(options?: { [key: string]: any }) {
  return request<CoreAPI.BaseResponse>(
    '/bossApi/conference/core/auth/v1/logout',
    {
      method: 'POST',
      ...(options || {}),
    },
  );
}
